import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=bf1696fe&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1696fe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Wrapper.vue
// module id = null
// module chunks = 